module.exports = new __parcel__URL__("Saas.c9b6742c.svg").toString();